<template>
  <div class="box" @click="to">
   <img src="https://s6.bihukankan.com/img/1694487186Group 4373.svg" alt=""><span>{{ searchName }}</span>
  </div>
</template>

<script>
export default {
  props:{
    tab:String
  },
  data() {
    return {}
  },
  methods: {
    to() {
      this.$router.push({ path:'/search', query:{ tab:this.tab } })
    }
  },
  computed:{
    searchName() {
      if(this.tab === 'anchor') {
        return '找达人'
      } else if(this.tab === 'shop') {
        return '搜店铺'
      } else if(this.tab === 'videoBox') {
        return '搜视频'
      }else if(this.tab === 'brand') {
        return '查品牌'
      } else if(this.tab === 'commodity') {
        return '搜商品'
      }
    }
  },
}
</script>

<style scoped lang="less">
.box {
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f9f7f8;
    color: #A1AEBF;
    font-size: 14px;
    span {
      margin-left: 5px;
    }
    img {
      width: 17px;
      height: 17px;
    }
}
</style>
